//@flow
import {makeStyles} from '@material-ui/core';
import React from 'react';
import CustomTextField from '../../../../../../../elements/CustomTextField/CustomTextField';
import {useFormContext} from 'react-hook-form';
import {POPUP_BANNER_FIELDS} from '../constants';

const useStyles = makeStyles(theme => ({
  textField: {
    maxWidth: '320px',
  },
}));

export default function PopupBannerTrigger() {
  const classes = useStyles();

  const {register, errors} = useFormContext();

  return (
    <div className={classes.root}>
      <CustomTextField
        className={classes.textField}
        placeholder="5"
        name={POPUP_BANNER_FIELDS.TRIGGER_VALUE}
        inputRef={register({
          required: 'Campo obligatorio',
          pattern: {
            value: /^[0-9]*$/,
            message: 'Solo números',
          },
        })}
        InputProps={{
          endAdornment: 'Segundos',
        }}
        error={!!errors[POPUP_BANNER_FIELDS.TRIGGER_VALUE]}
        helperText={errors[POPUP_BANNER_FIELDS.TRIGGER_VALUE]?.message}
      />
    </div>
  );
}
